export enum BuildingControlEnum {
  WaitingSubmit = 'รายการจัดซื้อจัดจ้าง',
  Donate = 'รายการรับบริจาค',
  Transfer = 'รายการรับโอน',
  Discovered = 'รายการสำรวจพบ',
  WaitTransfer = 'สินทรัพย์รอโอน'
}

export enum BuildingControlMenuEnum {
  AssetsList = 'รายการครุภัณฑ์',
}

export enum BuildingDetailEnum {
  AssetData = 'ข้อมูล',
  RepairMaintenance = 'ซ่อมและบำรุงรักษา',
  History = 'ประวัติการรักษา',
  AssetsHistory = 'ประวัติครุภัณฑ์',
  UseOfVehicles = 'การใช้รถ',
  Fuel = 'การใช้เชื้อเพลิง',
  ActInsurance = 'พรบ/ประกันภัย',
  Tax = 'ภาษี',
  Battery = 'แบตเตอรี่',
  Tire = 'ยาง',
  Accident = 'อุบัติเหตุ',
  Other = 'อื่นๆ'
}

export enum BuildingInspectionEnum {
  WaitingSubmit = 'รายการจัดซื้อจัดจ้าง',
}

export enum StatusInspecProcessEnum {
  WaitingPass = 'รอผ่านรายการ',
  WaitingChecked = 'รอตรวจสอบ',
  WaitingDoing = 'รอดำเนินการ ',
  Reject = 'ไม่อนุมัติ',
  Complete = 'ตรวจรับแล้ว',
  CompleteDepot = 'อนุมัติแล้ว',
  waitingApprove = 'รออนุมัติ',
  WaitingInspecPass = 'รอยืนยันรหัสครุภัณฑ์',
  WaitingReturnTranfer = 'รอรับจ่ายพัสดุ',
  WaitingForLending = 'รอผ่านการจัดสรรครุภัณฑ์',
  WaitingForDirectTransfer = 'รอผอ.อนุมัติจัดสรร',
  Waitingtodelivery = 'รอจ่ายพัสดุ',
  WaitingForTransfer = 'รอรับพัสดุ',
  DuringBorrow = 'อยุ่ระหว่างการยืม',
  DuringReturn = 'รอรับพัสดุคืน',
  ReturnComplete = 'ส่งคืนพัสดุแล้ว',
  WaitingForTransferOut = 'รอโอน ',
  TransferOutComplete = 'ยืนยันการโอน',
  WaitingForTransferOutComplete = 'ยืนยันรหัสครุภัณฑ์',
  WaitingForFixGf = 'รอปรับปรุงรหัส GFMIS',
  WaitingForFixGfComplete = 'รอยินยันรหัส GFMIS',
  CompleteFixGf = 'การเบิกต่อเสร็จสิ้น',

}

export enum DurableBuildingInspectionEnum {
  WAITING_APPROVE = 1,      // รออนุมัติการตรวจรับ
  APPROVED = 2,            // ตรวจรับแล้ว
  INSPECTING = 3,          // รอตรวจสอบ
  WAIT_CONFIRM = 4,        // รอยืนยันจำหน่ายออก
  REJECTED = 90,           // ไม่ผ่าน
  CENTER_REJECTED = 91,    // ไม่ผ่าน (ส่วนกลาง)
  NOT_APPROVED = 92,       // ไม่อนุมัติ
  TRANSFERRED = 7,         // รอโอนออก
  TRANSFERRED_OUT = 8      // โอนออกแล้ว
}

export enum BuildingControlStatusEnum {
  Active = 'ใช้งาน',
  WaitTransfer = 'รอโอน',
  WaittoConfirm = 'รอยืนยันจำหน่ายออก',
  Amortization = 'ตัดจำหน่าย',
  AmortizationOut = 'จำหน่ายออก',
  BorrowProcess = 'อยู่ระหว่างการยืม',
  ReturnProcess = 'ส่งคืน',
  TranFerProcess = 'โอนย้าย',
}


export enum BuildingEditTypeEnum {
  AssetDetailEdit = 'รายละเอียดครุภัณฑ์',
  LandAndUnit = 'สถานที่ตั้ง/หน่วยงานที่รับผิดชอบ',
  AssetNoEdit = 'หมายเลขครุภัณฑ์',
  AssetCashType = 'ประเภทเงินและการได้มาของสินทรัพย์',
  EditSeller = 'ข้อมูลผู้ขาย/ผู้รับจ้าง/ผู้บริจาค',
  Other = 'ข้อมูลอื่นๆ',
  Img = 'รูปภาพ'
}

// แก้ไข Enum ให้ตรงกับตัวเลือกที่แสดงในภาพ
export enum BuildingControlMarketEnum {
  EMarket = '1',
  EBidding = '2',
  PriceSurvey = '3',  // สอบราคา
  Selection = '4',    // คัดเลือก
  SpecificMethod = '5',  // เฉพาะเจาะจง
  Other = '6'         // อื่นๆ
}
